/** Sesli uyarı: yeni 🎯 AÇ (isteğe bağlı 🔭 EMİR KOY) kararı çıkınca kısa bir ton. Web Audio, dosya yok. */
const KEY = 'cds:sound:v1';
export const DEFAULT_SOUND = { enabled: true, volume: 0.6, ac: true, emirKoy: false };
export const SOUND_ACTIONS = { AC: 'ac', EMIR_KOY: 'emirKoy' };
export const COOLDOWN_MS = 10 * 60 * 1000; // aynı coin + karar 10 dk içinde tekrar çalmaz
export const GAP_MS = 2500; // iki ton arası en az boşluk

export function loadSettings() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? { ...DEFAULT_SOUND, ...JSON.parse(raw) } : { ...DEFAULT_SOUND };
    } catch {
        return { ...DEFAULT_SOUND };
    }
}

export function saveSettings(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* private mode */ }
}

/** prev: Map(symbol → action). Returns new map + the symbols whose decision just BECAME AC / EMIR_KOY.
 *  First load (empty prev) and symbols never seen before produce no events — no false alarm on page open. */
export function diffDecisions(prev, rows) {
    const next = new Map();
    const events = [];
    for (const r of rows || []) {
        const v = r?.verdict;
        if (!r?.symbol || !v?.action) continue;
        next.set(r.symbol, v.action);
        const was = prev.get(r.symbol);
        if (prev.size > 0 && was && was !== v.action && SOUND_ACTIONS[v.action]) {
            events.push({ symbol: r.symbol, action: v.action, direction: v.direction, action_tr: v.action_tr, emoji: v.emoji });
        }
    }
    return { next, events };
}

let ctx = null;
export function audioState() {
    if (typeof window === 'undefined' || !(window.AudioContext || window.webkitAudioContext)) return 'unsupported';
    return ctx ? ctx.state : 'idle';
}

function getCtx() {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
}

/** Tarayıcı, ilk kullanıcı dokunuşundan önce ses çalmaz — ilk tıklamada kilidi aç. */
export function installUnlock(onChange) {
    const unlock = () => {
        const c = getCtx();
        if (c) c.resume().then(() => onChange?.(c.state)).catch(() => {});
        window.removeEventListener('pointerdown', unlock);
        window.removeEventListener('keydown', unlock);
    };
    window.addEventListener('pointerdown', unlock);
    window.addEventListener('keydown', unlock);
    return () => {
        window.removeEventListener('pointerdown', unlock);
        window.removeEventListener('keydown', unlock);
    };
}

function note(c, freq, t0, dur, gain, type = 'sine') {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    o.frequency.setValueAtTime(freq, t0);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(gain, t0 + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    o.connect(g).connect(c.destination);
    o.start(t0);
    o.stop(t0 + dur + 0.02);
}

/** AC: belirgin, iki yükselen nota (E5 → A5). EMIR_KOY: tek yumuşak nota (C5). */
export function playTone(action, volume = 0.6) {
    const c = getCtx();
    if (!c || c.state !== 'running') return false;
    const v = Math.max(0, Math.min(1, volume));
    const t = c.currentTime + 0.01;
    if (action === 'AC') {
        note(c, 659.25, t, 0.16, 0.5 * v, 'triangle');
        note(c, 880.0, t + 0.15, 0.3, 0.55 * v, 'triangle');
        note(c, 1760.0, t + 0.15, 0.3, 0.12 * v, 'sine');
    } else {
        note(c, 523.25, t, 0.22, 0.3 * v, 'sine');
    }
    return true;
}
